import * as React from 'react';
// form
import { useFormContext, Controller } from 'react-hook-form';
import { cn } from '../../lib/utils';
import { sxParaEstilo } from './RHFTextField';

/* ============================================================================
   Interruptor (on/off) do visual novo. Sem MUI.

   Assinatura preservada: `name`, `label`, `size` e o que ia para o
   FormControlLabel (`sx`, `disabled`). `size` nao era so decoracao no MUI, e
   aqui muda de verdade a altura do trilho - por isso continua tendo efeito.

   Continua sendo um <input type="checkbox"> de verdade, so pintado: e o que da
   navegacao por Tab, tecla Espaco e leitura correta pelo leitor de tela de
   graca. `role="switch"` para o leitor anunciar "ativado/desativado" em vez de
   "marcado". O trilho e desenhado com `peer-checked`, entao nao existe estado
   duplicado em React para sair de sincronia.

   forwardRef pelo mesmo motivo do RHFCheckbox: as telas antigas envolvem estes
   campos em <Tooltip> do MUI, que injeta um ref no filho.
   ============================================================================ */

export default React.forwardRef(function RHFSwitch(
  { name, label, size = 'medium', sx, className, disabled, labelPlacement, color, ...resto },
  ref
) {
  const { control } = useFormContext();
  const idCampo = `switch-${name}`;
  const pequeno = size === 'small';

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <label
          {...resto}
          ref={ref}
          htmlFor={idCampo}
          style={sxParaEstilo(sx)}
          className={cn(
            'inline-flex cursor-pointer items-center gap-2 text-[12.5px] text-ink',
            disabled && 'cursor-not-allowed text-muted-foreground',
            className
          )}
        >
          <span className="relative inline-flex flex-none items-center">
            <input
              id={idCampo}
              type="checkbox"
              role="switch"
              name={field.name}
              ref={field.ref}
              onChange={field.onChange}
              onBlur={field.onBlur}
              checked={Boolean(field.value)}
              disabled={Boolean(disabled)}
              className="peer sr-only"
            />
            <span
              aria-hidden
              className={cn(
                'block rounded-full bg-line transition-colors peer-checked:bg-primary peer-disabled:opacity-50',
                // Anel de foco no TRILHO: o input esta em sr-only, entao sem isto
                // a navegacao por teclado nao mostra onde esta o foco.
                'peer-focus-visible:ring-2 peer-focus-visible:ring-primary',
                pequeno ? 'h-4 w-7' : 'h-5 w-9'
              )}
            />
            <span
              aria-hidden
              className={cn(
                'pointer-events-none absolute left-0.5 rounded-full bg-surface shadow-card transition-transform',
                pequeno ? 'h-3 w-3 peer-checked:translate-x-3' : 'h-4 w-4 peer-checked:translate-x-4'
              )}
            />
          </span>
          {label && <span>{label}</span>}
        </label>
      )}
    />
  );
});
